import React from 'react';
import { IPaymentMethodGroup } from '../types';

interface IBankCellProps {
  paymentMethodGroup: IPaymentMethodGroup;
}

export const BankCell: React.FC<IBankCellProps> = ({ paymentMethodGroup }) => {
  return <span>{paymentMethodGroup.name}</span>;
};
